import styled, { css } from "styled-components";
import { FlatButton, Flex, Message, transition } from "@evergis/ui";

import { LEFT_PANEL_MIN_WIDTH } from "components/Layout/constants";

export const LabelSettingsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ScrollableContainer = styled.span`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow: auto;
  flex-grow: 1;
`;

export const LibraryWithPreview = styled(Flex)`
  align-items: center;
`;

export const StyleTitle = styled.div`
  margin-bottom: 0.5rem;
  font: 400 1.25rem Roboto, Tahoma;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const Settings = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: ${`${LEFT_PANEL_MIN_WIDTH - 48}px`};
`;

export const SymbolScaleContainer = styled.div`
  border-bottom: 1px ${({ theme: { palette } }) => palette.elementDeep} solid;
`;

export const SymbolScaleHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  font-size: 0.75rem;

  span[kind="settings"] {
    cursor: pointer;
    transition: color ${transition.hover};

    &:hover {
      color: ${({ theme: { palette } }) => palette.primary};
    }
  }
`;

export const SymbolScaleButton = styled.div<{ active?: boolean }>`
  cursor: pointer;
  color: ${({ theme: { palette }, active }) => (active ? palette.primary : palette.textPrimary)};
  transition: color ${transition.hover};

  span[kind="scale"] {
    margin-right: 0.5rem;
    color: ${({ theme: { palette }, active }) => (active ? palette.primary : palette.icon)};
    transition: color ${transition.hover};
  }

  &:hover {
    color: ${({ theme: { palette } }) => palette.primary};

    span[kind="scale"] {
      color: ${({ theme: { palette } }) => palette.primary};
    }
  }
`;

export const SegmentSelectorContainer = styled(Flex)`
  width: calc(100% - 3.8rem);
  padding: 0 1.9rem 2.25rem;
`;

const SegmentSelectorLabelMixin = css`
  position: absolute;
  top: 0.75rem;
  left: -0.5rem;
  width: 0.9rem;
  text-align: center;
  font: ${({ theme: { fonts } }) => fonts.description};
  transition: color ${transition.hover};
`;

type SegmentSelectorTrackProps = {
  max: number;
  start: number;
  end?: number;
  active?: number;
  activeTrack?: boolean;
};

export const SegmentSelectorTrack = styled.div<SegmentSelectorTrackProps>`
  position: relative;
  width: ${({ max, start, end }) => `calc(${(Math.abs(end - start) / max) * 100}% - 2px)`};
  margin: 0 1px;
  height: 0.25rem;
  background-color: ${({ theme: { palette }, activeTrack }) => (activeTrack ? palette.primary : palette.elementDark)};
  transition: background-color ${transition.hover};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme: { palette }, activeTrack }) => (activeTrack ? palette.primary : palette.elementDeep)};
  }

  &:before,
  &:after {
    ${SegmentSelectorLabelMixin};
  }

  &:before {
    content: "${({ start }) => start}";
    color: ${({ theme: { palette }, activeTrack }) => (activeTrack ? palette.primary : palette.iconDisabled)};
  }

  &:after {
    content: "${({ end, max }) => (end === max ? end : "")}";
    left: auto;
    right: -0.5rem;
    color: ${({ theme: { palette }, start, active }) => (start === active ? palette.primary : palette.iconDisabled)};
  }
`;

export const InvalidStyleContainer = styled(Flex)`
  justify-content: center;
  padding: 1.5rem;

  ${Message} {
    font-size: 0.75rem;
    white-space: pre-line;
  }

  ${FlatButton} {
    margin-top: 1rem;
    max-width: 24em;
  }
`;

export const SingleObjectContainer = styled.div`
  margin-top: 2rem;
`;
